module.exports = require("@swa-ui/core/src/Flyout/PortalWrapper.module.scss");